import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import Layout from '../../containers/Layout';
import { Container, Content } from './styles';
import ImageTitle, { Icons } from '../../components/ImageTitle';
import Button from '../../components/Button';
import { useDefaultGtm } from '../../hooks/gtm/default/useDefaultGtm';

const OrderNotFound: React.FC = () => {
  const { goBack } = useHistory();
  const { sendDataToGtm } = useDefaultGtm();

  useEffect(() => {
    sendDataToGtm(
      { type: 'checkout', name: '/pagamento/infos-pagamento-error' },
      undefined,
      false,
    );
  }, []);

  return (
    <Layout dark>
      <Container>
        <ImageTitle
          data-cy='order-not-found'
          icon={Icons.alertOrder}
          text="Ops! Não encontramos nenhum pedido aguardando pagamento para esse CPF!"
          primary
        />
        <Content>
          Verifique se o número do CPF está correto ou entre em contato com o
          vendedor para confirmar as informações de venda.
        </Content>
        <Content>
          <Button theme="MINIMAL" onClick={goBack}>
            Tentar novamente
          </Button>
        </Content>
      </Container>
    </Layout>
  );
};

export default OrderNotFound;
